import dayjs from "dayjs";
import store from "../../../../../stateManagement/store";

/**
 * Validate Usability limits data
 * @returns 
 */
export const validateUsabilityLimits = ()=>{
    const {startDate , endDate } = store.getState()?.manageCoupons?.data?.usabilityLimits;
    const temp:Record<string,string> = {};
    if(startDate > endDate && startDate!==null && endDate !==null){
        temp['startDate']='Start Date should be less than end date';
        temp['endDate']='End Date should be greater than start date';
    }
    if(startDate!==null && startDate < dayjs().startOf('day')){
        temp['startDate']='Start Date cannot be less than today';
    }
    if(endDate!==null && endDate < dayjs().startOf('day')){
        temp['endDate']='End Date cannot be less than today';
    }
    return temp;
} 

export const isUsabilityLimitNotSelected = ()=>{
    const {startDate , endDate } = store.getState()?.manageCoupons?.data?.usabilityLimits; 
    return startDate === null && endDate === null;
}
